export const selectBorderColor = ({ disabled = false, hasError = false, readOnly = false }) => {
    if (hasError) {
        return 'twds-border-red-500 dark:twds-border-red-500';
    }
    let defaultStyle = '';
    if (!(disabled || readOnly)) {
        defaultStyle =
            'hover:twds-border-gray-600 dark:hover:twds-border-gray-600 focus-within:twds-border-blue-700 dark:focus-within:twds-border-blue-400 focus-within:hover:twds-border-blue-700 dark:focus-within:hover:twds-border-blue-400';
    }
    return `twds-border-gray-300 dark:twds-border-gray-500/30 ${defaultStyle}`;
};
export const textBoxPadding = (size = 'md', rightPadding = true) => {
    let padding;
    switch (size) {
        case 'sm':
            padding = `twds-pl-2 twds-py-1 ${rightPadding && 'twds-pr-2'}`;
            break;
        case 'md':
            padding = `twds-pl-4 twds-py-2 ${rightPadding && 'twds-pr-4'}`;
            break;
        case 'lg':
            padding = `twds-pl-4 twds-py-2.5 ${rightPadding && 'twds-pr-4'}`;
            break;
        default:
            padding = `twds-pl-4 twds-py-2 ${rightPadding && 'twds-pr-4'}`;
    }
    return padding;
};
export const rootPadding = (size = 'md') => {
    let padding;
    switch (size) {
        case 'sm':
            padding = 'twds-pr-2';
            break;
        case 'md':
            padding = 'twds-pr-4';
            break;
        case 'lg':
            padding = 'twds-pr-4';
            break;
        default:
            padding = 'twds-pr-4';
    }
    return padding;
};
export const resizeIconContainerPadding = (size = 'md') => {
    let padding;
    switch (size) {
        case 'sm':
            padding = 'twds-p-2';
            break;
        case 'md':
            padding = 'twds-pt-2.5 twds-pr-2 twds-pb-2';
            break;
        case 'lg':
            padding = 'twds-py-2.5 twds-pr-2';
            break;
        default:
            padding = 'twds-pt-2.5 twds-pr-2 twds-pb-2';
    }
    return padding;
};
export const iconContainerPadding = (size = 'md') => {
    let padding;
    switch (size) {
        case 'sm':
            padding = 'twds-py-0.5';
            break;
        case 'md':
            padding = 'twds-py-1.5';
            break;
        case 'lg':
            padding = 'twds-py-2.5';
            break;
        default:
            padding = 'twds-py-1.5';
    }
    return padding;
};
//# sourceMappingURL=textarea.logic.js.map